<template>


    <svg width="125" height="125" viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
            <rect x="2" y="2" width="125" height="125" stroke="transparent" stroke-width="4" fill="transparent" class="collider"/>
            <path class="color_changed_fill" d="M38 62.619L44.1364 45.9524L57.6364 40L65.6136 41.1905L73.5909 40L86.4773 45.9524L92 62.619L83.4091 65L80.9545 57.8571L82.3294 90H49.0455L50.2727 57.8571L47.8182 65L38 62.619Z" fill="#BD9135" stroke="#474849" stroke-linecap="round" stroke-linejoin="round"/>
            <mask id="path-2-inside-1_1405_1174" fill="white">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M63.1472 52.008H64.8424V54.5457L66.9709 52H68.797L64.8424 56.6407V58.4904L70.4978 52.004H72.289L67.5949 57.6585L73 65L71.172 64.9965L66.4869 58.6998L65.6377 59.6536L69.4556 65L67.4662 64.9965L64.8424 61.3181V64.9946H63.1472V58.9623L62.9992 58.736L61.7476 60.4205V64.9946H60V52H61.7039V58.2936L63.1472 56.5946V52.008Z"/>
            </mask>

        </g>
    </svg>


</template>

<script>
    export default {
        name: 'Coach',
        props: {
            screenWidth: {
                type: Number,
                default: 0
            },
            number: {
                type: Number,
                default: 1
            }
        }
    }
</script>

<style lang="scss" scoped>
    @font-face {
        font-family: 'Avenir';
        src: url('@/desktopApp/assets/fonts/AvenirLTStd-Black.otf');
    }
</style>